import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/** @jsx $jsx */
import { $jsx } from 'framework7';
import '../../../css/star-rating.css';
import user from '../../../js/stores/user.js';
import language from '../../../js/stores/language.js';
import carLoanRating from '../../../js/stores/car-loan-rating.js';
import RatingForm from './rating-form.f7.html';
import RatingDisplay from './rating-display.f7.html';
var RatingTab = function RatingTab(props, _ref) {
  var $h = _ref.$h,
    $f7 = _ref.$f7,
    $update = _ref.$update,
    $onMounted = _ref.$onMounted;
  var locale = language.getters.Item.value;
  var isOwner = user.getters.carId.value == props.data.CarMainData.CarId ? true : false;
  var isBorrower = user.getters.carId.value != props.data.CarMainData.CarId ? true : false;
  var showBorrowerForm = false;
  var showLenderForm = false;
  var showBorrowerRating = false;
  var showLenderRating = false;
  var borrowerStarLabel = locale.translate('loan.rating.starLabel', [locale.translate('loan.dashboard.borrower')]);
  var borrowerUserLabel = locale.translate('loan.rating.userLabel', [locale.translate('loan.dashboard.borrower')]);
  var borrowerRatingData = {};
  var lenderStarLabel = locale.translate('loan.rating.starLabel', [locale.translate('loan.dashboard.lender')]);
  var lenderUserLabel = locale.translate('loan.rating.userLabel', [locale.translate('loan.dashboard.lender')]);
  var lenderRatingData = {};
  $onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var objLender, resultLender, objBorrower, resultBorrower;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          objLender = {
            referenceId: props.data.CarLoanData.CarLoanId,
            fromId: props.data.CarLoanData.BorrowerId
          };
          _context.next = 1;
          return carLoanRating.dispatch('getRatingForLender', objLender);
        case 1:
          resultLender = _context.sent;
          if (isBorrower && resultLender.status !== undefined && resultLender.status !== 200) {
            showBorrowerForm = true;
          } else {
            borrowerRatingData = resultLender.status !== 400 ? resultLender : {};
          }
          if (Object.keys(borrowerRatingData).length > 0) showBorrowerRating = true;
          objBorrower = {
            referenceId: props.data.CarLoanData.CarLoanId,
            fromId: props.data.CarMainData.ContactId
          };
          _context.next = 2;
          return carLoanRating.dispatch('getRatingForBorrower', objBorrower);
        case 2:
          resultBorrower = _context.sent;
          if (isOwner && resultBorrower.status !== undefined && resultBorrower.status !== 200) {
            showLenderForm = true;
          } else {
            lenderRatingData = resultBorrower.status !== 400 ? resultBorrower : {};
          }
          if (Object.keys(lenderRatingData).length > 0) showLenderRating = true;
          $update();
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })));
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page-content tab" id="tab-8-rating">
  <div class="block">
    ${showBorrowerForm && $h`
      <${RatingForm} data=${props.data} action="ratingLender" />
    `}
    ${showLenderForm && $h`
      <${RatingForm} data=${props.data} action="ratingBorrower" />
    `}
    ${showBorrowerRating && $h`
      <${RatingDisplay} user-rating-data=${borrowerRatingData} star-label=${borrowerStarLabel} user-label=${borrowerUserLabel} />
    `}
    ${showLenderRating && $h`
      <${RatingDisplay} user-rating-data=${lenderRatingData} star-label=${lenderStarLabel} user-label=${lenderUserLabel} />
    `}
  </div>
</div>
`
    }
    ;
};
export default RatingTab;